import { Form } from '@unform/web';
import styled from 'styled-components';

export const WrapperForm = styled(Form)`
  form {
    > div > div {
      margin-bottom: 1rem;
    }
  }
`;
